var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarpet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22578 12.6975L7.14391 2.70063C7.25542 2.26557 7.20868 1.80503 7.01203 1.40125C6.83378 1.05442 6.56334 0.763456 6.23045 0.560349C5.89756 0.357242 5.51511 0.249857 5.12516 0.25H5.00016C4.36386 0.250106 3.74728 0.470863 3.25551 0.874649C2.76374 1.27843 2.42722 1.84026 2.30328 2.46438L0.285156 12.5588",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.75H8.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 13.25C3.35706 13.25 3.57962 13.1578 3.74372 12.9937C3.90781 12.8296 4 12.6071 4 12.375V12.375C4 12.1429 3.90781 11.9204 3.74372 11.7563C3.57962 11.5922 3.35706 11.5 3.125 11.5H3C2.60218 11.5 2.22064 11.658 1.93934 11.9393C1.65804 12.2206 1.5 12.6022 1.5 13V13C1.5 13.3978 1.65804 13.7794 1.93934 14.0607C2.22064 14.342 2.60218 14.5 3 14.5H3.125C3.40406 14.5 3.68039 14.445 3.9382 14.3382C4.19602 14.2315 4.43028 14.0749 4.6276 13.8776C4.82493 13.6803 4.98145 13.446 5.08824 13.1882C5.19504 12.9304 5.25 12.6541 5.25 12.375V12.375C5.25 12.0959 5.19504 11.8196 5.08824 11.5618C4.98145 11.304 4.82493 11.0697 4.6276 10.8724C4.43028 10.6751 4.19602 10.5185 3.9382 10.4118C3.68039 10.305 3.40406 10.25 3.125 10.25H3C2.27065 10.25 1.57118 10.5397 1.05546 11.0555C0.539731 11.5712 0.25 12.2707 0.25 13V13C0.25 13.7293 0.539731 14.4288 1.05546 14.9445C1.57118 15.4603 2.27065 15.75 3 15.75H13.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.25H14.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.75H14",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 8.25H13.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.75H13.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 11.25H13.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.75H13",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.25H12.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpet);
export default __webpack_public_path__ + "static/media/carpet.21f03d6c.svg";
export { ForwardRef as ReactComponent };